import { useEffect, useState } from "react";

export function useMapboxToken() {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/config/mapbox")
      .then((res) => res.json())
      .then((data) => setToken(data.token || null));
  }, []);

  return token;
}
